import classnames from 'classnames';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

export const SkeletonStatus: FC<{ color: 'info' | 'secondary' }> = ({ color }) => (
  <div className={classnames('w-100 alert alert-discreet-primary d-flex mb-0 position-relative', `text-${color}`)}>
    <div className="d-flex flex-column">
      <span className="pe-2">
        <Skeleton width="1em" />
      </span>
      <Skeleton width="15em" />
    </div>
  </div>
);
